import Vue from 'vue'
import Vuex from 'vuex'
Vue.config.debug = true //开启错误提示

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 32.0107067424, 118.7333258122 园林局位置
        // 32.058771, 118.791208 气象局位置

        // 用户所在位置
        userPosition: {},

        // 保存地图点击的位置
        // clickPositionObj:{lng:'118.791208',lat:'32.058771'},//默认位置 positionObj
        clickPositionObj: {
            lng: 118.791208,
            lat: 32.058771,
            street: '北京东路'
        },

        initStreesInfo: {
            '320100': {
                city: '南京市',
                county: '玄武区',
                streetName: '北京东路',
                shortStreetName: '北京东路',
                lnglat: [118.791208, 32.058771], //默认位置
                acode: '025', //首页道路搜索城市设置
                treeTypes: [] //设置树种
            },
            '320800': {
                city: '淮安市',
                county: '清江浦区',
                streetName: '淮海南路',
                shortStreetName: '淮海南路',
                lnglat: [119.02932391889999, 33.589011574699995], //默认位置
                acode: '0517', //首页道路搜索城市设置
                treeTypes: [] //设置树种
            },
            '110100': {
                city: '北京市',
                county: '西城区',
                streetName: '西长安大街',
                shortStreetName: '西长安大街',
                lnglat: [116.3883749189, 39.9073325747], //默认位置
                acode: '010', //首页道路搜索城市设置
                treeTypes: [
                    { type: 'all', name: '全部' },
                    { type: 'wutong', name: '梧桐' },
                    { type: 'yangshu', name: '杨树' },
                    { type: 'liushu', name: '柳树' }
                ] //设置树种
            }
        },

        piaoxuLevelObj: [
            { label: '无飘絮', id: 'none', name: 'indexDescription', value: '0' },
            { label: '轻度飘絮', id: 'mild', name: 'indexDescription', value: '1' },
            { label: '中度飘絮', id: 'moderate', name: 'indexDescription', value: '2' },
            { label: '重度飘絮', id: 'severe', name: 'indexDescription', value: '3' }
        ],
        uploadImgCountObj: [
            { imgid: 'camera_img_1', _src: '', _click: 'camera_input_1.click();', fileid: 'camera_input_1' },
            { imgid: 'camera_img_2', _src: '', _click: 'camera_input_2.click();', fileid: 'camera_input_2' },
            { imgid: 'camera_img_3', _src: '', _click: 'camera_input_3.click();', fileid: 'camera_input_3' },
            { imgid: 'camera_img_4', _src: '', _click: 'camera_input_4.click();', fileid: 'camera_input_4' }
        ],
        failLiveData: [
            {
                status: 0
            },
            {
                live: {
                    streetId: 0,
                    streetName: '',
                    indexLiveValue: 0,
                    level: '无',
                    publishTime: '--:-- 发布',
                    accurate: '100%',
                    notaccurate: '0%',
                    maxUncorrect: '100%',
                    maxLevel: '无',
                    description: '飘絮预报业务尚未覆盖您当前所在区域数据，敬请期待!'
                }
            },
            {
                forcast: {
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    xdata: ['10-16\n17:00', '10-16\n20:00', '10-16\n23:00', '10-17\n02:00', '10-17\n05:00', '10-17\n08:00', '10-17\n11:00', '10-17\n14:00', '10-17\n17:00', '10-17\n20:00', '10-17\n23:00', '10-18\n02:00', '10-18\n05:00', '10-18\n08:00', '10-18\n11:00', '10-18\n14:00']
                }
            }
        ],
        unCorrectLevel: [
            { type: 3, level: '重度' },
            { type: 2, level: '中度' },
            { type: 1, level: '轻度' },
            { type: 0, level: '无' }
        ]
    },
    mutations: {
        updateParam(state, param) {
            let attr, data
            if (param.length > 1) {
                ;[attr, data] = param
            } else {
                ;[data] = param
            }
            let keys = Object.keys(data)
            for (let key of keys) {
                if (!!attr) {
                    state[attr][key] = data[key]
                } else {
                    state[key] = data[key]
                }
            }
        }
    },
    actions: {
        updateParam({ commit }, param) {
            commit('updateParam', param)
        }
    }
})
export default store



// WEBPACK FOOTER //
// ./src/store.js